import script from "./SurveyPopupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyPopupModal.vue?vue&type=script&setup=true&lang=js"

import "./SurveyPopupModal.vue?vue&type=style&index=0&id=628d909c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-628d909c"]])

export default __exports__